module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_blue_02-395e9976b850a3193013f93ee4657b94.svg";